import VWindow from './VWindow'
import VWindowItem from './VWindowItem'

export { VWindow, VWindowItem }

export default {
  $_ifrontui_subcomponents: {
    VWindow,
    VWindowItem,
  },
}
